import React, { useEffect, useState } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Page from 'Components/Page';
import * as actions from 'Store/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter, Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import RegistrationCodeRow from 'Components/RegistrationCodeRow';
import Divider from 'Components/Divider';
import IconButton from '@material-ui/core/IconButton';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import firebaseService from 'Services/firebaseService';
import EditIcon from '@material-ui/icons/Edit';
import Button from '@material-ui/core/Button';
import history from '../../history';

const pageStyles = theme => ({
  pageWrapper: {
    paddingLeft: '4%',
    paddingRight: '4%',
  },
  itemContainer: {
    marginTop: '50px',
  },
  registerTagButton: {
    marginTop: '20px',
  },
  pageHeader: {
    marginTop: '40px',
  },
});

function RegDashboard({ user, classes, setActiveModal }) {
  const [regCodes, setRegCodes] = useState([]);

  useEffect(() => {
    (async function () {
      try {
        const regCodes = await firebaseService.getUserRegCodes();
        setRegCodes(regCodes);
      } catch (err) {
        console.warn('Get reg codes server error: ', err);
        return;
      }
    })();
  }, [setRegCodes, user]);

  async function editItem(item) {
    history.push('/product-registration/edit-code');
  }

  function renderDeleteItemButton(itemId) {
    return (
      <IconButton className={classes.button} aria-label="delete" size="small">
        <DeleteForeverIcon
          fontSize="small"
          onClick={() => {
            setActiveModal(`delete-item-${itemId}`);
          }}
        />
      </IconButton>
    );
  }

  function renderEditItemButton(item) {
    return (
      <IconButton className={classes.button} aria-label="delete" size="small">
        <EditIcon onClick={() => editItem(item)} fontSize="small" />
      </IconButton>
    );
  }

  function renderItems(items) {
    return items.map((item, index) => {
      // When there is no image
      const image = (item.images && item.images[0]) || '';

      return (
        <div key={item.itemId} className={classes.itemContainer}>
          <RegistrationCodeRow
            name={item.name}
            productUrl=""
            itemId={item.regCodeId}
            message={item.message}
            phone={item.phone}
            imageUrl={image}
            secondaryHeaderContent={
              <>
                {renderEditItemButton(item)}
                {renderDeleteItemButton(item.itemId)}
              </>
            }
          />
          {index < items.length - 1 && <Divider />}
        </div>
      );
    });
  }

  const renderPageContent = () => {
    if (regCodes.length === 0) {
      return (
        <>
          <Typography variant="body1">You have not created any registration codes</Typography>
          <Button
            type="button"
            variant="contained"
            color="primary"
            to="/product-registration/add-code"
            className={classes.registerTagButton}
            component={Link}
          >
            &#43; Create New Code
          </Button>
        </>
      );
    }

    return (
      <>
        {/* <Typography variant="h5">Registered Tags:</Typography> */}
        {renderItems(regCodes)}
      </>
    );
  };

  return (
    <Page wrapperStyles={classes.pageWrapper}>
      <Typography variant="h2" className={classes.pageHeader}>
        Registration Codes
      </Typography>
      <Button
        type="button"
        variant="contained"
        size="small"
        color="primary"
        to="/product-registration/add-code"
        className={classes.registerTagButton}
        component={Link}
      >
        &#43; Create New Code
      </Button>
      {renderPageContent()}
    </Page>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      deleteItem: actions.deleteItem,
      setActiveModal: actions.setActiveModal,
    },
    dispatch,
  );
}

function mapStateToProps({ user, activeModal }) {
  if (!user) {
    history.replace('/');
  }

  return {
    user,
    activeModal,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(pageStyles)(RegDashboard)));
